import useSmallScreen from "../../../../components/useSmallScreen";
import LiveStreamBottomLargeScreenControls from "./LiveStreamBottomLargeScreenControls";
import LiveStreamBottomSmallScreenControls from "./LiveStreamBottomSmallScreenControls";

function LiveStreamBottomControls({ showFullScreen, viewingLiveStream,username,roomName }) {
  const [smallScreen] = useSmallScreen();
  return smallScreen ? (
    <LiveStreamBottomSmallScreenControls
      showFullScreen={showFullScreen}
      viewingLiveStream={viewingLiveStream}
    />
  ) : (
    <LiveStreamBottomLargeScreenControls
      viewingLiveStream={viewingLiveStream}
      roomName={roomName}
      username={username}
    />
  );
}

export default LiveStreamBottomControls;
